export default function EventCardSkeleton() {
  return (
    <div className="block rounded-3xl overflow-hidden shadow-xl bg-zinc-900/40 border border-zinc-800/50 h-full">
      {/* Image Placeholder */}
      <div className="relative h-56 w-full bg-zinc-800/50 animate-pulse">
        <div className="absolute top-4 right-4 h-6 w-20 bg-zinc-700/50 rounded-full"></div>
      </div>
      
      {/* Content Placeholder */}
      <div className="p-6 flex flex-col gap-4">
        {/* Title */}
        <div className="h-8 w-3/4 bg-zinc-800/50 rounded-lg animate-pulse"></div>
        
        {/* Meta info (date/location) */}
        <div className="flex gap-3">
          <div className="h-4 w-24 bg-zinc-800/30 rounded animate-pulse"></div>
          <div className="h-4 w-32 bg-zinc-800/30 rounded animate-pulse"></div>
        </div>
        
        {/* Description */}
        <div className="space-y-2">
          <div className="h-4 w-full bg-zinc-800/30 rounded animate-pulse"></div>
          <div className="h-4 w-5/6 bg-zinc-800/30 rounded animate-pulse"></div>
        </div>
        
        {/* Button */}
        <div className="h-12 w-full bg-zinc-800/50 rounded-xl mt-2 animate-pulse"></div>
      </div>
    </div>
  )
}

